import React, { Fragment, useEffect, useState } from "react";
import { notificationsColumn } from "Constants/TableColumns";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import { read } from "Helpers/LocalStorage";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import NotificationsService from "Services/http/endpoints/notifications/NotificationsService";
import StatusHandler from "Helpers/StatusHandler";
import { useDispatch, useSelector } from "react-redux";
import { GETAGAINNOTIFICATION } from "Stores/actionTypes";

function NotificationTable() {
  const dispatch = useDispatch();
  const { getNotification } = useSelector((state) => ({
    getNotification: state.notification.getNotification,
  }));
  const [loading, setLoading] = useState(false);
  const [firstEnter, setSetFirstEnter] = useState(true);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [tblData, setTblData] = useState([]);

  const onTableChange = async (type, { page, sizePerPage }) => {
    if (type === "pagination") {
      const params = {
        keyGroup: read("groupKey"),
        keyUser: read("userKey"),
        Limit: sizePerPage,
        Page: page,
      };
      await getData(params);
    }
  };

  const getData = async (params) => {
    try {
      setLoading(true);
      const response = await NotificationsService.getNotifications(params);
      const err = StatusHandler(response);
      if (!err.isFail) {
        setTblData(response.data.Value);
        setCurrentPage(response.data.Pagination.Page);
        setSizePerPage(response.data.Pagination.Limit);
        setTotal(response.data.Pagination.Total);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (getNotification || firstEnter) {
      setLoading(true);
      setSetFirstEnter(false);
      (async () => {
        const params = {
          keyGroup: read("groupKey"),
          keyUser: read("userKey"),
          Limit: sizePerPage,
          Page: currentPage,
        };
        await getData(params);
        dispatch({
          type: GETAGAINNOTIFICATION,
          status: false,
        });
      })();
    }
  }, [getNotification]);

  return (
    <Fragment>
      <BackDropLoading loading={loading} />
      {tblData && (
        <RemoteTable
          data={tblData}
          columns={notificationsColumn}
          page={currentPage}
          sizePerPage={sizePerPage}
          totalSize={total}
          onTableChange={onTableChange}
        />
      )}
    </Fragment>
  );
}

export default NotificationTable;
